export default __webpack_public_path__ + "static/media/orange1.0987a45e.svg";